var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.securityId)?_c('div',{staticClass:"fds-egb-alert-trigger-controls"},[_c('fds-alert-trigger-controls',{attrs:{"locale":_vm.locale,"security-id":_vm.id,"data-test-id":"alert-trigger-controls"},on:{"exchange-change":_vm.onExchangeChange}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }